export default "__VITE_ASSET__keDDa$Pb__"